import { INotification } from 'models/notification.model'
import api from './api'
import { getRegisterIdFromStore } from 'util/storeHelpers'

const getAllNotifications = async (): Promise<Array<INotification>> => {
  // add header to the request for registerId
  const { data } = await api.get<Array<INotification>>('/v1/notification', {
    headers: {
      registerId: getRegisterIdFromStore(),
    },
  })
  return data
}

const getNotificationById = async (_id: string): Promise<INotification> => {
  const { data } = await api.get<INotification>(`/v1/notification/${_id}`)
  return data
}

const patchNotificationById = async (_id: string, notification: any): Promise<INotification> => {
  const { data } = await api.put(`/v1/notification/${_id}`, notification)
  return data
}

export default {
  getAllNotifications,
  getNotificationById,
  patchNotificationById,
}
